var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "employees-card-bottom" },
        [
          _c("oaFromBox", {
            staticClass: "from-box",
            attrs: {
              search: _vm.search,
              isViewSearch: false,
              sortSearch: false,
              total: _vm.total,
              type: "0",
              title: _vm.$route.meta.title,
              btnText: "一键转移",
              btnType: "default",
            },
            on: {
              addDataFn: function ($event) {
                return _vm.confirmTransfer(1)
              },
              confirmData: _vm.confirmData,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "mt10",
            },
            [
              _vm.tableData.length == 0
                ? _c("div", { staticClass: "defaultPage" }, [
                    _c("img", {
                      staticClass: "img",
                      attrs: {
                        src: require("../../../assets/images/defd.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "text" }, [
                      _vm._v(" 暂无发票数据"),
                    ]),
                  ])
                : _c("div", {}, [
                    _c(
                      "div",
                      {
                        staticStyle: { width: "100%", overflow: "auto" },
                        style: { height: _vm.tableHeight },
                      },
                      _vm._l(_vm.tableData, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "table-box" },
                          [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "header" },
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      model: {
                                        value: _vm.checkList,
                                        callback: function ($$v) {
                                          _vm.checkList = $$v
                                        },
                                        expression: "checkList",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          staticClass: "header-left",
                                          attrs: { label: item.id },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm._f("titleTypeFn")(
                                                  item.types
                                                )
                                              ) +
                                              "·" +
                                              _vm._s(
                                                item.collect_type === "mail"
                                                  ? "电子"
                                                  : "纸质"
                                              ) +
                                              "\n                    "
                                          ),
                                          item.status === 0
                                            ? _c("el-tag", [_vm._v("待审核")])
                                            : item.status === 1
                                            ? _c(
                                                "el-tag",
                                                { attrs: { type: "warning" } },
                                                [_vm._v("待开票")]
                                              )
                                            : item.status === 2
                                            ? _c(
                                                "el-tag",
                                                { attrs: { type: "danger" } },
                                                [_vm._v("已拒绝")]
                                              )
                                            : item.status === 3
                                            ? _c(
                                                "el-tag",
                                                { attrs: { type: "info" } },
                                                [_vm._v("撤回开票")]
                                              )
                                            : item.status === 4
                                            ? _c(
                                                "el-tag",
                                                { attrs: { type: "danger" } },
                                                [_vm._v("申请作废")]
                                              )
                                            : item.status === 5
                                            ? _c(
                                                "el-tag",
                                                { attrs: { type: "success" } },
                                                [_vm._v("已开票")]
                                              )
                                            : _c("el-tag", [_vm._v("已作废")]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "left" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: ["customer:invoice:check"],
                                              expression:
                                                "['customer:invoice:check']",
                                            },
                                          ],
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleCheck(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("public.check")) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.status === 0
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.invoiceWithdrawal(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    撤回开票\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.status === 5
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleBuild(
                                                    item,
                                                    _vm.buildData
                                                      .void_invoice_switch,
                                                    "void_invoice_switch"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    申请作废\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.buildData.length > 1
                                        ? _c(
                                            "el-dropdown",
                                            {
                                              attrs: {
                                                trigger: "click",
                                                size: "small",
                                                placement: "bottom-start",
                                              },
                                              on: {
                                                command: function ($event) {
                                                  return _vm.handleBuild(
                                                    $event,
                                                    6,
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small",
                                                  },
                                                },
                                                [_vm._v(" 申请作废 ")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-dropdown-menu",
                                                {
                                                  staticClass: "build-dropdown",
                                                  attrs: { slot: "dropdown" },
                                                  slot: "dropdown",
                                                },
                                                _vm._l(
                                                  _vm.buildData,
                                                  function (item, index) {
                                                    return _c(
                                                      "el-dropdown-item",
                                                      {
                                                        key: item.id,
                                                        staticClass:
                                                          "over-text",
                                                        attrs: {
                                                          placement: "top-end",
                                                          command: index,
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "iconfont",
                                                          class: item.icon,
                                                          style: {
                                                            color: item.color,
                                                          },
                                                        }),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(item.name) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.status === 4
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.invoiceWithdrawal(
                                                    item,
                                                    1
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    作废撤回\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              item.types == "3"
                                ? _c("div", { staticClass: "content main" }, [
                                    _c(
                                      "div",
                                      { staticClass: "left" },
                                      [
                                        _c(
                                          "el-form",
                                          { attrs: { "label-width": "110px" } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "发票抬头：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "pointer copy",
                                                    attrs: {
                                                      title: "点击复制",
                                                      "data-clipboard-text":
                                                        item.title,
                                                    },
                                                    on: { click: _vm.copy },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          item.title || "--"
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "纳税人识别号：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "pointer copy",
                                                    attrs: {
                                                      title: "点击复制",
                                                      "data-clipboard-text":
                                                        item.ident,
                                                    },
                                                    on: { click: _vm.copy },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          item.ident || "--"
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "开票金额：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "pointer copy",
                                                    class:
                                                      item.price == item.amount
                                                        ? ""
                                                        : "active",
                                                    attrs: {
                                                      title: "点击复制",
                                                      "data-clipboard-text":
                                                        item.amount,
                                                    },
                                                    on: { click: _vm.copy },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.amount || "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "line" }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "right" },
                                      [
                                        _c(
                                          "el-form",
                                          { attrs: { "label-width": "110px" } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "客户名称：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.customer
                                                        ? item.customer
                                                            .customer_name
                                                        : "--"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            item.collect_type == "mail"
                                              ? _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "邮箱信息：",
                                                      prop: "name",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pointer copy",
                                                        attrs: {
                                                          title: "点击复制",
                                                          "data-clipboard-text":
                                                            item.collect_email,
                                                        },
                                                        on: { click: _vm.copy },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.collect_email ||
                                                              "--"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "邮寄信息：",
                                                      prop: "name",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pointer copy text-height",
                                                        attrs: {
                                                          title: "点击复制",
                                                          "data-clipboard-text":
                                                            item.collect_name +
                                                            item.collect_tel +
                                                            item.mail_address,
                                                        },
                                                        on: { click: _vm.copy },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.collect_name
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              item.collect_tel
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              item.mail_address ||
                                                                "--"
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "申请信息：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.card
                                                          ? item.card.name
                                                          : ""
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        item.created_at || "--"
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "付款金额：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class:
                                                      item.price == item.amount
                                                        ? ""
                                                        : "active",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.price || "--")
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.types == "2"
                                ? _c("div", { staticClass: "content main" }, [
                                    _c(
                                      "div",
                                      { staticClass: "left" },
                                      [
                                        _c(
                                          "el-form",
                                          { attrs: { "label-width": "110px" } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "发票抬头：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "pointer copy",
                                                    attrs: {
                                                      title: "点击复制",
                                                      "data-clipboard-text":
                                                        item.title,
                                                    },
                                                    on: { click: _vm.copy },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          item.title || "--"
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "纳税人识别号：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "pointer copy",
                                                    attrs: {
                                                      title: "点击复制",
                                                      "data-clipboard-text":
                                                        item.ident,
                                                    },
                                                    on: { click: _vm.copy },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          item.ident || "--"
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "开票金额：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "pointer copy",
                                                    class:
                                                      item.price == item.amount
                                                        ? ""
                                                        : "active",
                                                    attrs: {
                                                      title: "点击复制",
                                                      "data-clipboard-text":
                                                        item.amount,
                                                    },
                                                    on: { click: _vm.copy },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          item.amount || "--"
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "line" }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "right" },
                                      [
                                        _c(
                                          "el-form",
                                          { attrs: { "label-width": "110px" } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "客户名称：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.customer
                                                        ? item.customer
                                                            .customer_name
                                                        : "--"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            item.collect_type == "mail"
                                              ? _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "邮箱信息：",
                                                      prop: "name",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pointer copy",
                                                        attrs: {
                                                          title: "点击复制",
                                                          "data-clipboard-text":
                                                            item.collect_email,
                                                        },
                                                        on: { click: _vm.copy },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.collect_email ||
                                                              "--"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "邮寄信息：",
                                                      prop: "name",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pointer copy text-height",
                                                        attrs: {
                                                          title: "点击复制",
                                                          "data-clipboard-text":
                                                            item.collect_name +
                                                            item.collect_tel +
                                                            item.mail_address,
                                                        },
                                                        on: { click: _vm.copy },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.collect_name
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              item.collect_tel
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              item.mail_address ||
                                                                "--"
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "申请信息：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.card
                                                          ? item.card.name
                                                          : ""
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        item.created_at || "--"
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "付款金额：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class:
                                                      item.price == item.amount
                                                        ? ""
                                                        : "active",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.price || "--")
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.types == "1"
                                ? _c("div", { staticClass: "content" }, [
                                    _c(
                                      "div",
                                      { staticClass: "left" },
                                      [
                                        _c(
                                          "el-form",
                                          { attrs: { "label-width": "110px" } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "发票抬头：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "pointer copy",
                                                    attrs: {
                                                      title: "点击复制",
                                                      "data-clipboard-text":
                                                        item.title,
                                                    },
                                                    on: { click: _vm.copy },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          item.title || "--"
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "开票金额：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "pointer copy",
                                                    class:
                                                      item.price == item.amount
                                                        ? ""
                                                        : "active",
                                                    attrs: {
                                                      title: "点击复制",
                                                      "data-clipboard-text":
                                                        item.amount,
                                                    },
                                                    on: { click: _vm.copy },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.amount || "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "line" }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "right" },
                                      [
                                        _c(
                                          "el-form",
                                          { attrs: { "label-width": "110px" } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "客户名称：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.customer
                                                        ? item.customer
                                                            .customer_name
                                                        : "--"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            item.collect_type == "mail"
                                              ? _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "邮箱信息：",
                                                      prop: "name",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pointer copy",
                                                        attrs: {
                                                          title: "点击复制",
                                                          "data-clipboard-text":
                                                            item.collect_email,
                                                        },
                                                        on: { click: _vm.copy },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.collect_email ||
                                                              "--"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "邮寄信息：",
                                                      prop: "name",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pointer copy text-height",
                                                        attrs: {
                                                          title: "点击复制",
                                                          "data-clipboard-text":
                                                            item.collect_name +
                                                            item.collect_tel +
                                                            item.mail_address,
                                                        },
                                                        on: { click: _vm.copy },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.collect_name
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              item.collect_tel
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              item.mail_address ||
                                                                "--"
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "申请信息：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.card
                                                          ? item.card.name
                                                          : ""
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        item.created_at || "--"
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "付款金额：",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class:
                                                      item.price == item.amount
                                                        ? ""
                                                        : "active",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.price || "--")
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "page-fixed" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "page-size": _vm.where.limit,
                            "current-page": _vm.where.page,
                            "page-sizes": [15, 20, 30],
                            layout: "total, sizes,prev, pager, next, jumper",
                            total: _vm.total,
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.pageChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("invoice-apply", {
        ref: "invoiceApply",
        attrs: { "form-data": _vm.formBoxConfig },
        on: {
          isOk: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
      _vm._v(" "),
      _c("mergeInvoice", {
        ref: "mergeInvoice",
        attrs: { "form-data": _vm.formBoxConfig },
        on: {
          isOk: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
      _vm._v(" "),
      _c("invoice-details", {
        ref: "invoiceDetailsView",
        attrs: { "form-data": _vm.invoiceData },
      }),
      _vm._v(" "),
      _c("invoice-view", {
        ref: "invoiceView",
        attrs: { "form-data": _vm.invoiceData },
      }),
      _vm._v(" "),
      _c("mark-dialog", {
        ref: "markDialog",
        attrs: { config: _vm.configMark },
        on: {
          isMark: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
      _vm._v(" "),
      _c("transfer-dialog", {
        ref: "transferDialog",
        attrs: { "from-data": _vm.transferData },
        on: { handleTransfer: _vm.getTableData },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "addBox",
          attrs: {
            title: _vm.title,
            top: "25vh",
            "append-to-body": true,
            visible: _vm.dialogVisible,
            width: "540px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              staticClass: "from",
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.reason + "：",
                    "label-width": "90px",
                    prop: "remarks",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", placeholder: "请填写原因" },
                    model: {
                      value: _vm.form.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small" },
                      on: { click: _vm.cancelFn },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.submitFn },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("edit-examine", {
        ref: "editExamine",
        attrs: { parameterData: _vm.parameterData },
        on: {
          isOk: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }